export default __webpack_public_path__ + "static/media/screenshot_edl.cd02c321.webp";